module.exports = __webpack_public_path__ + "static/media/auction.34ab9311.svg";